import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { MarkdownModule } from 'ngx-markdown';
import { MarkdownComponent } from './markdown.component';
import { TextService } from './text.service';


@NgModule({
  declarations: [MarkdownComponent],
  imports: [
    MarkdownModule.forRoot(),
    CommonModule,
    SharedRoutingModule
  ],
  exports: [
    MarkdownComponent
  ],
  providers: [
    TextService
  ]

})
export class SharedModule { }
